import(/* webpackMode: "eager" */ "/vercel/path0/src/app/explore/page.tsx");
